<!--
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2023-10-09 10:19:22
 * @LastEditors: DESKTOP-ROEB53E\caiyangjie 1760178806@qq.com
 * @LastEditTime: 2024-01-22 16:17:48
 * @FilePath: \合联\oms\src\view\analysis\gccOrderStatistics\order.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    isTabs
    ref="table"
  >
  </cTable>
</template>

<script>
import cTable from "@/base/common/index";
import { apis } from "@/api/analysis/financialRevenue";
export default {
  name: "",
  components: {
    cTable
  },
  props: {
    name: {
      type: String,
      default: ""
    },
    data: {
      type: Object,
      default() {
        return {};
      }
    },
    headers: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  mounted() {
    console.log(apis);
    this.header.searchs.splice(
      0,
      0,
      ...this.headers.filter(t => {
        if (t.includes) {
          return t.includes.includes(this.name);
        } else return true;
      })
    );
  },
  data() {
    return {
      methods: {
        ...apis,
        list: p => {
          return this.data.list(p);
        },
        beforeHandleList: ({ data, list }) => {
          this.fields.splice(1, this.fields.length);
          data.header.forEach(item => {
            this.fields.push({
              name: item.name,
              key: item.key,
              minWidth: 120,
              children:
                item.children &&
                item.children.map(t => {
                  t.minWidth = 120;
                  return t;
                })
            });
          });
          return data.data;
        }
      },
      config: {
        tabHeight: -30,
        slot: "div",
        isGetList: true
      },
      footer: {
        show: () => false
      },
      modals: {
        upload: {
          methods: {
            ok() {
              window.open(this.$globalUrl + "/doc/zh-CN/finance.xlsx");
            }
          },
          footer: {
            cancel: {
              isShow: true
            },
            ok: {
              name: this.$t("download_tem")
            }
          },
          config: {
            modalBind: {
              width: 500,
              draggable: true,
              maskClosable: false
            },
            rowBind: {
              gutter: 16
              // style: {
              //   marginBottom: "20px"
              // }
            },
            title: this.$t("upload") + this.$t("files")
          },
          grid: [{ files: 24 }],
          fields: [
            {
              key: "files",
              component: "Upload",
              bind: {
                type: "drag",
                accept: ".xlsx"
              },
              methods: {
                beforeUpload: ({ file }) => {
                  let _this = this.$refs["table"];
                  _this
                    .handleRequestMethods("excel", {
                      file
                    })
                    .then(res => {
                      _this.$Message["success"]({
                        background: true,
                        content: res.msg
                      });
                      _this.getModal("upload").close();
                    });
                  return false;
                }
              }
            }
          ]
        }
      },
      header: {
        searchs: [],
        btns: {
          list: [
            {
              name: () => this.$tz("导出"),
              type: "export",
              fnName: "export",
              bind: {
                type: "primary"
              }
            },

            {
              name: () => this.$tz("导入"),
              type: "import",
              fnName: "import",
              bind: {
                type: "primary"
              }
            }
            // {
            //   name: () => this.$tz("详情,导出"),
            //   type: "detail",
            //   fnName: "detail",
            //   bind: {
            //     type: "primary"
            //   }
            // }
          ],
          methods: {
            import() {
              this.getModal("upload").open({}, function() {
                this.setTitle(this.$tz("导入"));
              });
            },
            export: () => {
              let table = this.$refs["table"];
              table.selectAll = table.list;
              table.exportExc(this.$t(this.$route.name) + "-" + this.name);
            },
            detail({ searchForm }) {
              this.handleRequestMethods(
                "list",
                Object.assign({ export: 1 }, searchForm),
                false,
                true
              ).then(res => {
                this.$Message.success(res.msg);
              });
            }
          }
        }
      },
      fields: []
    };
  }
};
</script>

<style scoped></style>
